import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
  ProfileNavbarContainerStyled,
  ProfileTabsStyled,
  ProfileTabStyled,
} from './styles/DashboardProfileNavbarStyles';
import AtomTypography from '../../../components/atoms/AtomTypography/AtomTypography';
import AvatarComponent from '../../../components/generics/AvatarComponent/AvatarComponent';
import { styleConfigs } from '../../../components/resources/styleConfigs';
import { INavItemProps } from '../../../components/template-minimal/NavItem/NavItem';
import BoxWrapper from '../../../components/wrappers/BoxWrapper';
import { getTestAttrs, TestIdContext } from '../../../constants/testingAttributes';
import userAuth from '../../../hooks/userAuth';
import { PATH_DASHBOARD_STUDENT } from '../../../routes/paths';
import palette from '../../../theme/learnerPalette';
import sidebarProfileConfiguration from '../SidebarProfileConfiguration/SidebarProfileConfiguration';

const DashboardProfileNavbar: React.FC = ({ children }) => {
  const [value, setValue] = useState<string>(PATH_DASHBOARD_STUDENT.profile.information);

  const { auth } = userAuth();
  const navigate = useNavigate();
  const { t: tSidebarProfile } = useTranslation('SidebarProfileConfiguration');
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down('sm'));

  const studentInitials = `${auth?.student?.name?.replace(/\s/g, '')?.[0] ?? ''}${
    auth?.student?.lastName?.replace(/\s/g, '')?.[0] ?? ''
  }`;

  useEffect(() => {
    setValue(window.location.pathname);
  }, []);

  return (
    <ProfileNavbarContainerStyled>
      {!isMobile && (
        <BoxWrapper
          pt={styleConfigs.marginPadding.custom4}
          mb={styleConfigs.marginPadding.custom32px}
          display="flex"
          alignItems="center"
          gap={styleConfigs.marginPadding.custom24rem}
        >
          <AvatarComponent
            nameInitials={auth?.student?.name && studentInitials}
            size={styleConfigs.dimensions.width102}
          />
          <AtomTypography
            variant="h1"
            fontWeight={500}
            fontSize={styleConfigs.fonts.fontSize45}
            color={palette.light.text.ebonyClay}
          >
            {tSidebarProfile('PROFILE')}
          </AtomTypography>
        </BoxWrapper>
      )}
      <ProfileTabsStyled
        value={value}
        variant="standard"
        textColor="secondary"
        indicatorColor="secondary"
        aria-label={tSidebarProfile('PROFILE_NAV_ARIA_LABEL')}
      >
        {sidebarProfileConfiguration(tSidebarProfile).map((list) => {
          const { items } = list;

          return items.map((item: INavItemProps) => (
            <ProfileTabStyled
              key={item.title}
              id={`profile-tab-${item.path.split('/').pop()}`}
              aria-controls="profile-tabpanel"
              label={item.title}
              value={item.path}
              onClick={() => {
                setValue(item.path);
                navigate(item.path);
              }}
              {...getTestAttrs(TestIdContext.PROFILE, 'tab', undefined, item.path.split('/').pop() ?? '')}
            />
          ));
        })}
      </ProfileTabsStyled>
      <div role="tabpanel" id="profile-tabpanel" aria-labelledby={`profile-tab-${value.split('/').pop()}`}>
        {children}
      </div>
    </ProfileNavbarContainerStyled>
  );
};

export default DashboardProfileNavbar;
